import http from './http';

export interface RecruiterNotePayload {
  candidateProfileId: string;
  notes: string;
  tags: string[];
}

export const recruiterNoteApi = {
  create: (body: RecruiterNotePayload) => http.post('/recruiter-notes', body).then(r => r.data),
  update: (id: string, body: Partial<RecruiterNotePayload>) => http.patch(`/recruiter-notes/${id}`, body).then(r => r.data),
};
